import React, { useEffect, useRef, useState } from 'react';
// import ClearIcon from '../../../../media/icons/assets_light/outline-action-close-active.svg';
import Checklist from './Checklist';
import { useSelector } from 'react-redux';
import { useTaskContext } from '../../../../context/TaskContext';

export default function DescriptionSection() {

  const [isReadOnly, setIsReadOnly] = useState(true);
  const { active_task } = useSelector(state => state.task)
  const toggleEditMode = () => {
    setIsReadOnly(false);
  };

  const { OnUpdateTask, updateLoader } = useTaskContext()
  const textareaRef = useRef(null);
  const [notes, setNotes] = useState(active_task?.notes || '');

  useEffect(() => {
    setNotes(active_task?.notes);
  }, [active_task]);

  useEffect(() => {
    const focusTextarea = () => {
      if (!isReadOnly && textareaRef.current) {
        textareaRef.current.focus();
      }
    };
    const timeoutId = setTimeout(focusTextarea, 0);
    return () => clearTimeout(timeoutId);
  }, [isReadOnly]);

  useEffect(() => {
    if (textareaRef.current) {
      const textLength = notes?.length;
      textareaRef.current.selectionStart = textLength;
      textareaRef.current.selectionEnd = textLength;
      textareaRef.current.focus();
    }
  }, [notes]);

  const handleSave = () => {
    if (!isReadOnly && notes?.trim() !== active_task?.notes) {
      OnUpdateTask({ notes: notes.trim(), save_type: 'note' });
    }
    setIsReadOnly(true);
    // if (notes?.trim().length === 0) {
    // }
  };

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";

      const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight, 10);
      const maxHeight = lineHeight * 5;

      const newHeight = Math.min(textarea.scrollHeight, maxHeight);
      textarea.style.height = newHeight + "px";

      // Toggle scrollbar only if content exceeds maxHeight
      if (textarea.scrollHeight > maxHeight) {
        textarea.style.overflowY = "auto";
      } else {
        textarea.style.overflowY = "hidden";
      }
    }
  }, [notes]);

  return (
    <div className="mb-8">
      {/* Notes Section */}
      <div className="mb-4 mt-4">
        <p className="text-[12px] text-teal-600 dark:text-white">Notes</p>
        <div className="mt-1 relative">
          {!isReadOnly ? (
            <div className="">
              {/* <p className="text-sm text-slate-600 leading-relaxed">{task.notes}</p> */}
              <textarea
                ref={textareaRef}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                onBlur={handleSave}
                readOnly={isReadOnly}
                onClick={toggleEditMode}
                className="w-full border border-border-primary hover:border-border-action rounded-lg py-2 pl-2 pr-[12px] text-sm text-[#475569] resize-none focus:outline-none focus:border-border-focus max-h-[100px]"
                rows={1}
                placeholder="Add a note"
              />
            </div>
          ) : (
            <div className="bg-slate-50 border border-dashed border-slate-200 rounded-lg p-3.5 text-center">
              {active_task?.notes ? <p className="text-xs text-slate-600 leading-relaxed" onClick={toggleEditMode}>{active_task?.notes}</p>
                : <p className="text-xs text-slate-300 italic" onClick={toggleEditMode}>No notes added yet</p>
              }
            </div>
          )}
          {/* <textarea
            ref={textareaRef}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            onBlur={handleSave}
            readOnly={isReadOnly}
            onClick={toggleEditMode}
            className="w-full border border-border-primary hover:border-border-action rounded-lg py-2 pl-2 pr-[12px] text-sm text-[#475569] resize-none focus:outline-none focus:border-border-focus max-h-[100px]"
            rows={1}
            placeholder="Add a note"
          /> */}
          {/* {notes &&
            <div
              id="clearNot"
              onClick={() => setNotes('')}
              className={`absolute top-[8px] right-[8px] bg-[#636E82] hover:!bg-[#318FFF] dark:!bg-white w-[18px] h-[18px] cursor-pointer transition-all duration-300`}
              style={{
                WebkitMaskImage: `url(${ClearIcon})`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskPosition: "center",
                WebkitMaskSize: "contain",
                maskImage: `url(${ClearIcon})`,
                maskRepeat: "no-repeat",
                maskPosition: "center",
                maskSize: "contain",
              }}
            />
          } */}

        </div>
      </div>

      {/* Checklist Section */}
      <div className=" mt-2">
        <Checklist />
      </div>
    </div>
  );
}
